import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
  root: {
    textAlign: 'center',
    padding: theme.spacing(6, 2),
    color: theme.palette.text.secondary,
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
})

function EmptyState({ classes, title = '尚無資料', description }) {
  return (
    <div className={classes.root}>
      <Typography className={classes.title}>{title}</Typography>
      {description ? <Typography variant="body2">{description}</Typography> : null}
    </div>
  )
}

EmptyState.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
}

export default withStyles(styles)(EmptyState)
